
import { IGlobalState } from "@/store";
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import toExamine from "../modules/toExamine.vue";
import { ElMessage } from "element-plus";
import { examineApp, findAppList, examineDataPush } from "@/service/api";
import { useRouter } from "vue-router";

export default defineComponent({
  components: {
    toExamine,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      keyWord: "",
      delFactoryId: "",
      examineState: "",
      page: 1,
      limit: 10,
      applicationList: [],
      total_rows: 0,
      examineStr: "",
      userId: computed(() => store.state.manageUser.userId),
      name: computed(() => store.state.manageUser.name),
    });
    const visibleModal = ref(false);
    const loading = ref(true);
    /**
     * 获取厂商列表
     */
    const getApplications = async () => {
      loading.value = true;
      const params = {
        userId: "",
        examineState: state.examineState,
        keyWord: state.keyWord,
        page: state.page,
        limit: state.limit,
      };
      const result = await findAppList(params);
      if (result && parseInt(result.code) === 1) {
        state.applicationList = result.data.rows;
        state.total_rows = result.data.total_rows;
        loading.value = false;
      }
    };
    /**
     * 搜索
     */
    async function handleSearch() {
      state.page = 1;
      await getApplications();
    }
    //审核
    function openExamineModal(index: number, examineStr: string) {
      if (
        examineStr === "dataPushUrl" &&
        (state.applicationList[index] as any).dataPushUrl === ""
      ) {
        ElMessage({ message: "暂无数据推送地址，不能审核", type: "error" });
        return;
      }
      state.examineStr = examineStr;
      state.delFactoryId = (state.applicationList[index] as any).id;
      visibleModal.value = true;
    }
    //审核通过
    function addSubmit(val: any) {
      if (state.examineStr === "app") {
        sureExamineApp(val);
      } else {
        sureExamineDataPushUrl(val);
      }
    }
    //确认审核应用
    async function sureExamineApp(val: any) {
      const params = {
        id: state.delFactoryId,
        examineState: val.state,
        remark: val.remark,
        examUserid: state.userId,
        examRealname: state.name,
      };
      const result = await examineApp(params);
      if (result && parseInt(result.code) === 1) {
        ElMessage({ message: "审核成功", type: "success" });
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
      getApplications();
      closeModal();
    }
    //确认审核数据推送地址
    async function sureExamineDataPushUrl(val: any) {
      const params = {
        id: state.delFactoryId,
        examineState: val.state,
        remark: val.remark,
        examUserid: state.userId,
        examRealname: state.name,
      };
      const result = await examineDataPush(params);
      if (result && parseInt(result.code) === 1) {
        ElMessage({ message: "审核成功", type: "success" });
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
      getApplications();
      closeModal();
    }
    //关闭弹窗
    function closeModal() {
      visibleModal.value = false;
    }
    //跳转到审核学校页面
    function lookAuthSchool(index: number) {
      router.push({
        path: "/openapimgeAuthSchoolList",
        query: {
          id: (state.applicationList[index] as any).id,
          title: (state.applicationList[index] as any).title,
        },
      });
    }
    //跳转到api申请页面
    function lookApplyAPI(index: number) {
      router.push({
        path: "/openapimgeApplyAPIList",
        query: {
          id: (state.applicationList[index] as any).id,
          title: (state.applicationList[index] as any).title,
        },
      });
    }
    function headerStyle() {
      const cellStyle =
        "background: #ffffff;color: #333333;font-weight:700;width: 100%; font-size: 12px";
      return cellStyle;
    }
    /**
     * 初始加载数据
     */
    onMounted(async () => {
      await getApplications();
    });
    return {
      ...toRefs(state),
      visibleModal,
      loading,
      openExamineModal,
      getApplications,
      handleSearch,
      addSubmit,
      closeModal,
      lookAuthSchool,
      lookApplyAPI,
      headerStyle,
    };
  },
});
